<template>
  <el-dialog
    :visible.sync="visible"
    width="800px"
    class="dialog_detail"> 
    <template #title>
      <h4 class="color">历史流量 注:(以下流量为单月累计使用量，存在1-2天延迟)</h4>
    </template>
    <div class="flex">
      <div>
        <el-date-picker
          v-model="month"
          type="month"
          size="small"
          value-format="yyyy-MM"
          placeholder="选择月">
        </el-date-picker>
        <el-button type="primary" class="search" size="small" @click="getData">查询</el-button>
      </div>
      <el-button 
        v-if="!ids.includes(cardSupplier)" 
        size="small" 
        type="primary"
        class="showStatstics"
        @click="onoff = !onoff"
      >{{!onoff?'统计报表':'详情报表'}}</el-button>
    </div>
    <el-table
      :data="tableData"
      v-if="onoff"
      size="mini"
      stripe
      style="width: 100%;border:1px solid #EBF0F6;"
      height="500px">
      <el-table-column
        type="index"
        label="序号"
        width="55"
      />
      <el-table-column
        prop="simCard"
        align="center"
        label="SIM卡号"
        min-width="130"
        :formatter="formatterSimCard"
      />
      <el-table-column
        prop="useFlow"
        align="center"
        label="使用流量（MB）"
        min-width="130"
        :formatter="formatterUseFlow"
      />
      <el-table-column
        prop="time"
        align="center"
        label="时间"
        min-width="130"
      />
    </el-table>
    <el-table
      v-else
      :data="statisticsTableData"
      size="mini"
      stripe
      style="width: 100%;border:1px solid #EBF0F6;"
      height="500px">
      <el-table-column
        prop="index"
        align="center"
        label="序号"
        width="55"
      />
      <el-table-column
        prop="time"
        align="center"
        label="月份（当前年份下）"
        min-width="260"
      />
      <el-table-column
        prop="useFlow"
        align="center"
        label="使用流量（MB）"
        min-width="130"
        :formatter="formatterGprs"
      />
    </el-table>
  </el-dialog>
</template>
<script>
import axios from "../../api/apiConfig";
import { getUserType, hasDot } from "@/util/common";
export default {
  data(){
    return {
      month:'',
      onoff:true,
      visible:false,
      tableData:[],
      simCard:"123",
      iccid:'',
      cardSupplier:null,
      statisticsTableData:[],
      ids:[7,8,9,10,13,15,18],
    }
  },
  watch:{
    visible:{
      handler(val){
        val && this.getData();
      }
    }
  },
  methods:{
    //查看统计
    handleShow(){
      this.$refs.statisticsRefs.visible = true;
      this.$nextTick(()=>{
        this.$refs.statisticsRefs.init(this.iccid);
      })
    },
    //获取数据
    async getData(){
      !this.ids.includes(this.cardSupplier) && this.statistics();
      try{
        if(this.ids.includes(this.cardSupplier)) {
          const { code, msg, data } = await this.$API.readHistoryGprsFlow({ simCard:this.simCard, month:this.month });
          if(code != 0) return this.$message.error(msg);
          this.tableData = data;
        }else{
          const { code, msg, data } = await this.$API.historyReadHistoryGprsFlow({ iccid:this.iccid, month:this.month });
          if(code != 0) return this.$message.error(msg);
          this.tableData = data;
        }
      }catch(e){
        console.log(e)
      }
    },
    //查看统计数据
    async statistics(){
      try{
        const { code, msg, data } = await this.$API.monthlyStatisticsOldHistoryGprsFlow({ iccid:this.iccid });
        if(code != 0) return this.$message.error(msg);
        this.statisticsTableData = data;
      }catch(e){
        console.log(e)
      }
    },
    //流量转换
    formatterGprs({useFlow}) {
      if (!useFlow) return "0kb";
      const flow = Math.abs(Number(useFlow));
      const burden = Number(useFlow) > 0;
      if (flow > 1024 * 1024) {
        let num = flow / (1024 * 1024);
        return `${burden?'':'-'}${hasDot(num)}G`;
      } else if (flow > 1024) {
        let num = flow / 1024;
        return `${burden?'':'-'}${hasDot(num)}M`;
      } else {
        return `${burden?'':'-'}${flow}kb`;
      }
    },
    formatterUseFlow(row){
      return (row.useFlow/1024).toFixed(2)
    },
    formatterSimCard(){
      return this.simCard
    }
  }
}
</script>
<style lang="scss" scoped>
.color{
  color:red;
  padding: 10px;
  font-weight: 600;
  font-size: 18px;
}
/deep/ .el-dialog__body{
  padding: 10px !important;
} 
.showStatstics{
  float: right;
  margin-bottom:10px;
}
.flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .search{
    margin-left: 10px;
  }
}
</style>